import React from "react";

export const flagOutline = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="outlined_flag_24px">
        <path
          id="icon/content/outlined_flag_24px"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 3.5L13.5 5.5H19.5V15.5H12.5L11.5 13.5H6.5V20.5H4.5V3.5H12.5ZM13.5 13.5H17.5V7.5H12.5L11.5 5.5H6.5V11.5H12.5L13.5 13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
